import { render } from "./MenuPlatform.vue?vue&type=template&id=1e598a3a"
import script from "./MenuPlatform.vue?vue&type=script&lang=js"
export * from "./MenuPlatform.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__